/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { SchoolPagedData } from '../../models/school-paged-data';
import { SortType } from '../../models/sort-type';

export interface GetSchools$Params {
  PageNumber?: number;
  PageSize?: number;
  SearchTerm?: string;
  SortField?: string;
  SortType?: SortType;
}

export function getSchools(http: HttpClient, rootUrl: string, params?: GetSchools$Params, context?: HttpContext): Observable<StrictHttpResponse<SchoolPagedData>> {
  const rb = new RequestBuilder(rootUrl, getSchools.PATH, 'get');
  if (params) {
    rb.query('PageNumber', params.PageNumber, {});
    rb.query('PageSize', params.PageSize, {});
    rb.query('SearchTerm', params.SearchTerm, {});
    rb.query('SortField', params.SortField, {});
    rb.query('SortType', params.SortType, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<SchoolPagedData>;
    })
  );
}

getSchools.PATH = '/school';
